
import _ from 'lodash';
import { captureException } from '@sentry/browser';

export const validateState = (state, initialState) => {
  const validStateKeys = Object.keys(initialState);
  const stateKeys = Object.keys(state);
  const missingOrIncorrectlyDefinedKeys = _.xor(stateKeys, validStateKeys);
  if (missingOrIncorrectlyDefinedKeys.length > 0) {
    console.error(`Invalid or missing state keys found: ${missingOrIncorrectlyDefinedKeys}`);
    state.developerErrorMessage = `Invalid or missing state keys found: ${missingOrIncorrectlyDefinedKeys}`;
  }

  return state;
};

export const wrapAndValidateAsyncAction = (asyncFunction, initialState) => async function wrappedAsyncAction (state, action, dispatch) {
  return submitAction({
    dispatch,
    callback: async () => validateState(await asyncFunction({ state, action, dispatch }), initialState),
  });
};

export const validateStateReducerWrapper = (reducer, initialState) => {
  return (state, action) => {
    const updatedState = reducer(state, action);
    return action ? validateState(updatedState, initialState) : updatedState;
  };
};

export const submitAction = async function({ dispatch, callback }) {
  dispatch({ type: 'submit-start' });
  let response;
  try {
    response = await callback();
  } catch (e) {
    console.error(e);
    captureException(e);
  } finally {
    dispatch({ type: 'submit-complete' });
  }
  return response;
};
